import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { HelmetTitle } from "../../Components/Utils";
import Layout from "../../Components/Layout";
import Hero from "../../Components/Banner/index";
import HomeContent from "../../Components/Layout/HomeDisplay/index";
import "../index.css";



class Home extends Component {
  componentDidMount() {
      window.scrollTo(0,0);   
   }
  render() {
    return (
      <div className="App">
        <HelmetTitle title="Home" />
        <Layout head={<Hero />} body={<HomeContent/>}/>
      </div>);
  }
}

export default withRouter(Home)



// WEBPACK FOOTER //
// ./src/Pages/Home/index.js